import * as React from "react";

export interface IHorizontalRuleProps {
}

export class HorizontalRule extends React.Component<IHorizontalRuleProps, {}> {
    public render() {
        return (
            <div className="horizontal-rule">
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/ts/controls/rule.tsx